import { ServerComm } from "@quest/platform-murka-phase_2/dist";

export class GameServerComm extends ServerComm {
  
}